module.exports = __webpack_public_path__ + "media/images/back_1-666ca0e7cbe3beaedf1d6d46e1e24272.png";